// assets/shipping-delay-popup.js

document.addEventListener('DOMContentLoaded', function () {
  // How long (in days) before showing again once closed
  var hideDurationDays = 1;

  // Check if the customer has closed the popup recently
  var lastClosed = localStorage.getItem('shippingDelayClosedAt');
  if (lastClosed) {
    var closedDate = new Date(lastClosed);
    var now = new Date();
    var diffMs = now - closedDate;
    var diffDays = diffMs / (1000 * 60 * 60 * 24);

    if (diffDays < hideDurationDays) {
      // They closed it within the past day; do not show again
      return;
    }
  }

  // Show the popup
  var modal = document.getElementById('shipping-delay-modal');
  var closeBtn = document.getElementById('shipping-delay-close');
  if (!modal || !closeBtn) {
    return;
  }

  modal.style.display = 'flex';

  // When they click “×”, hide the popup and store the timestamp
  closeBtn.addEventListener('click', function () {
    modal.style.display = 'none';
    localStorage.setItem('shippingDelayClosedAt', new Date().toISOString());
  });

  // Also close if they click outside the container
  modal.addEventListener('click', function (e) {
    if (e.target === modal) {
      modal.style.display = 'none';
      localStorage.setItem('shippingDelayClosedAt', new Date().toISOString());
    }
  });
});
